import React from 'react';
import { FileText, AlertCircle, CheckCircle, Clock, ExternalLink } from 'lucide-react';
export function LicenseInformation() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-861">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-862">
        {/* Page Header */}
        <div className="mb-12" data-id="element-863">
          <div className="flex items-center justify-center mb-6" data-id="element-864">
            <FileText className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-865" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-866">
              License Information
            </h1>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mb-12 bg-brand-purple-50 rounded-lg p-6 border-2 border-brand-purple-200" data-id="element-867">
          <p className="text-lg text-gray-900 mb-4" data-id="element-868">
            <strong data-id="element-869">License and Course Information:</strong>{' '}
            <a href="/Products" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-870">
              Click here to see On-Demand class offerings
            </a>{' '}
            or{' '}
            <a href="/Login" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-871">
              Log In
            </a>
          </p>
        </div>

        {/* Key Information Bullets */}
        <div className="mb-12 space-y-4" data-id="element-872">
          <div className="flex items-start" data-id="element-873">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-874" />
            <p className="text-base text-gray-700" data-id="element-875">
              All classes are approved for renewal credit with the Arizona
              Department of Real Estate School #S06-0002
            </p>
          </div>
          <div className="flex items-start" data-id="element-876">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-877" />
            <p className="text-base text-gray-700" data-id="element-878">
              Our classes are text-based so there is no need to worry about
              audio or video issues.
            </p>
          </div>
          <div className="flex items-start" data-id="element-879">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-880" />
            <p className="text-base text-gray-700" data-id="element-881">
              The final exam will repeat the quiz questions and you will need to
              achieve at least 80% correct to pass.
            </p>
          </div>
          <div className="flex items-start" data-id="element-882">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-883" />
            <p className="text-base text-gray-700" data-id="element-884">
              When a class is completed you can print your certificate
              immediately from your Class History folder on your Dashboard.
            </p>
          </div>
          <div className="flex items-start" data-id="element-885">
            <CheckCircle className="w-6 h-6 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-886" />
            <p className="text-base text-gray-700" data-id="element-887">
              To be paperless when you click to print your certificate, a PDF
              will be downloaded to your computer. Save in a folder to retrieve
              class information.
            </p>
          </div>
        </div>

        {/* Salesperson Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-888">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-889">
            Salesperson
          </h2>
          <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-890">
            24 credit hours required every two years, with at least one class of
            each of the following credit type, plus 1 class for elective credit:
          </p>
          <ul className="space-y-2 mb-6" data-id="element-891">
            <li className="flex items-start" data-id="element-892">
              <span className="text-brand-purple-600 mr-2" data-id="element-893">*</span>
              <span className="text-base text-gray-700" data-id="element-894">Agency Law</span>
            </li>
            <li className="flex items-start" data-id="element-895">
              <span className="text-brand-purple-600 mr-2" data-id="element-896">*</span>
              <span className="text-base text-gray-700" data-id="element-897">Contract Law</span>
            </li>
            <li className="flex items-start" data-id="element-898">
              <span className="text-brand-purple-600 mr-2" data-id="element-899">*</span>
              <span className="text-base text-gray-700" data-id="element-900">Disclosure</span>
            </li>
            <li className="flex items-start" data-id="element-901">
              <span className="text-brand-purple-600 mr-2" data-id="element-902">*</span>
              <span className="text-base text-gray-700" data-id="element-903">Fair Housing</span>
            </li>
            <li className="flex items-start" data-id="element-904">
              <span className="text-brand-purple-600 mr-2" data-id="element-905">*</span>
              <span className="text-base text-gray-700" data-id="element-906">
                General - Deed Fraud, Firewise + AZ Water
              </span>
            </li>
            <li className="flex items-start" data-id="element-907">
              <span className="text-brand-purple-600 mr-2" data-id="element-908">*</span>
              <span className="text-base text-gray-700" data-id="element-909">Legal Issues</span>
            </li>
            <li className="flex items-start" data-id="element-910">
              <span className="text-brand-purple-600 mr-2" data-id="element-911">*</span>
              <span className="text-base text-gray-700" data-id="element-912">
                Requirements for Licensees (formerly Commissioner's Standards)
              </span>
            </li>
          </ul>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded" data-id="element-913">
            <p className="text-base text-gray-800" data-id="element-914">
              <strong data-id="element-915">1 class (3 hours) for elective credit</strong> - You may
              choose any credit type, providing you do not duplicate any course
              title you have already taken within that renewal period.
            </p>
          </div>
        </div>

        {/* Broker Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-916">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-917">
            Designated Broker, Self Employed Broker and Associate Broker in a
            supervisory role
          </h2>
          <p className="text-lg font-semibold text-gray-900 mb-4" data-id="element-918">
            30 credit hours required every 2 years.
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded" data-id="element-919">
            <p className="text-base text-gray-800 mb-3" data-id="element-920">
              The BMC Package includes all required courses plus Broker
              Management Clinic #1, #2, #3 for 30 hours
            </p>
            <p className="text-base text-gray-800" data-id="element-921">
              If your brokerage does property management, choose the Broker
              Package with BMC3B
            </p>
          </div>
        </div>

        {/* Timer Notice */}
        <div className="mb-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-922">
          <div className="flex items-start" data-id="element-923">
            <Clock className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-924" />
            <div data-id="element-925">
              <p className="text-base text-gray-800 mb-3" data-id="element-926">
                <strong data-id="element-927">NOTE:</strong> ADRE is requiring ALL credit hour classes
                (in-person and distance learning) to be timed for a total of 150
                minutes. To be compliant with ADRE rules, all of our On-Demand
                Platform classes have a timer.
              </p>
              <p className="text-base text-gray-800" data-id="element-928">
                As long as your class is open and your browser is running, the
                timer will continue to count down. If you click on another link,
                close your browser or shut off your computer while in a class,
                the timer will stop at that point and will begin at the spot you
                left off when you come back and click on the class title. If you
                are finished early, you can walk away and let the timer continue
                counting down to 0, as long as your device does not go to sleep
                and disconnects from the server.
              </p>
            </div>
          </div>
        </div>

        {/* Renewal Requirements */}
        <div className="mb-12 bg-white rounded-lg border-2 border-gray-200 p-8" data-id="element-929">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-930">
            Arizona Real Estate License Renewal Requirements
          </h2>
          <p className="text-base text-gray-700 mb-6" data-id="element-931">
            Complete hours of renewal credit (24 or 30) through any approved
            Real Estate school, within the 2 year period of the current license.
          </p>

          <div className="space-y-6" data-id="element-932">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-933">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-934">
                The Salesperson - 24 hours
              </h3>
              <p className="text-base text-gray-700 mb-3" data-id="element-935">
                Must include 21 hours in the 7 required class types. The last 3
                hours is your Elective and can be any class type you want*
              </p>
              <p className="text-sm text-gray-600 italic" data-id="element-936">
                Note: Additional General classes are accepted as elective credit
                ONLY
              </p>
              <p className="text-sm text-gray-600 italic mt-2" data-id="element-937">
                *While you may duplicate a course type to complete your 24
                hours, you may not duplicate a course number already taken
                during that renewal period. Different class name=Different
                course number
              </p>
            </div>

            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-938">
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-939">
                Designated Brokers (and Supervisory Associate Brokers) - 30
                hours
              </h3>
              <p className="text-base text-gray-700" data-id="element-940">
                Must include 9 hours BMC (Requirements for Licensees) and the
                balance of 21 hours are the 6 other required classes and 2
                elective credit in any course type* you desire.
              </p>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div className="mb-12 space-y-6" data-id="element-941">
          <div className="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-lg" data-id="element-942">
            <p className="text-base text-gray-800" data-id="element-943">
              You may pay for and renew your license up to 90 days prior to
              expiration
            </p>
          </div>

          <div className="bg-brand-purple-50 border-l-4 border-brand-purple-400 p-6 rounded-lg" data-id="element-944">
            <p className="text-base text-gray-800 mb-3" data-id="element-945">
              <strong data-id="element-946">NOTE:</strong> The Arizona Department of Real Estate
              (ADRE) is urging you to renew your real estate license online and
              offers a discounted cost for doing so.
            </p>
            <p className="text-base text-gray-800" data-id="element-947">
              Fee Schedule Link:{' '}
              <a href="https://azre.gov/all-adre-resources/fees" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline inline-flex items-center" data-id="element-948">
                https://azre.gov/all-adre-resources/fees
                <ExternalLink className="w-4 h-4 ml-1" data-id="element-949" />
              </a>
            </p>
          </div>

          <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg" data-id="element-950">
            <div className="flex items-start" data-id="element-951">
              <AlertCircle className="w-6 h-6 text-red-600 mr-3 mt-1 flex-shrink-0" data-id="element-952" />
              <p className="text-base text-gray-800" data-id="element-953">
                You must complete and report all of your CE credits by midnight
                of the calender day of the month that your license expires (that
                includes Saturdays, Sundays and Holidays). Log on at{' '}
                <a href="https://ptl.az.gov/dre/#/login" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-954">
                  https://ptl.az.gov/dre/#/login
                </a>{' '}
                and have your credit card ready along with all of your
                certificates for classes attended.
              </p>
            </div>
          </div>
        </div>

        {/* Contact CTA */}
        <div className="bg-brand-purple-50 rounded-lg p-8 text-center border border-brand-purple-100" data-id="element-955">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-956">
            Have Questions?
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-957">
            Our team is here to help you navigate your license renewal
            requirements.
          </p>
          <a href="/Contact" className="inline-flex items-center px-8 py-3 bg-brand-purple-600 text-white font-bold rounded-md hover:bg-brand-purple-700 transition-colors" data-id="element-958">
            Contact Us
          </a>
        </div>
      </div>
    </div>;
}